import {
  useCheckUserAcceptanceForLatestPrivacyPolicy,
  useCheckUserAcceptanceForLatestTermAndConditionQuery,
} from '@exam-room/graphql';
import { generatePath, Navigate } from 'react-router-dom';

import { LoadingSpinner } from '../../../components';
import { useExamCard, useNetwork } from '../../../providers';
import { PATHS } from '../../constants';

// NOTE: We name this as root since index is reserved
function Root() {
  const { examCard, loading: isLoadingExamCard } = useExamCard();
  const { isOnline } = useNetwork();
  const { data: CheckUserAcceptanceResult, loading: isCheckingUserAcceptance } =
    useCheckUserAcceptanceForLatestPrivacyPolicy();

  const {
    data: checkTermsAndConditionsUserAcceptanceResult,
    loading: isCheckingTermsAndConditionsUserAcceptanceResult,
  } = useCheckUserAcceptanceForLatestTermAndConditionQuery();

  const isLoading =
    isLoadingExamCard ||
    isCheckingUserAcceptance ||
    isCheckingTermsAndConditionsUserAcceptanceResult;

  if (isLoading || !isOnline) {
    return (
      <div className='grid h-dvh w-screen place-items-center'>
        <LoadingSpinner />
      </div>
    );
  }

  if (!examCard) {
    return <Navigate to={PATHS.Home} replace />;
  }

  if (CheckUserAcceptanceResult?.cluCheckUserAcceptanceForLatestPrivacyPolicy.isAccepted) {
    if (
      checkTermsAndConditionsUserAcceptanceResult?.cluCheckUserAcceptanceForLatestTermAndCondition
        .isAccepted
    ) {
      return <Navigate to={generatePath(PATHS.Exam.Instruction, { examCardId: examCard.id })} />;
    }
    return (
      <Navigate to={generatePath(PATHS.Exam.TermsAndConditions, { examCardId: examCard.id })} />
    );
  }

  return <Navigate to={generatePath(PATHS.Exam.PrivacyNotice, { examCardId: examCard.id })} />;
}

const RootRoute = {
  path: PATHS.Exam.Index,
  element: <Root />,
};

export default RootRoute;
